import { useState } from "react";
import { motion } from "framer-motion";
import { Menu, X } from "lucide-react";

const navLinks = [
  { label: "Ecosystem", href: "#ecosystem" },
  { label: "Tech", href: "#technology" },
  { label: "Contact", href: "#footer" },
];

const Navbar = () => {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <motion.nav
      data-testid="navbar"
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
      className="fixed top-0 left-0 right-0 z-50 nav-glass"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 lg:h-20">
          {/* Logo */}
          <a
            href="#hero"
            data-testid="nav-logo"
            className="relative text-xl lg:text-2xl font-bold tracking-tighter text-offWhite hover:text-cyanGlow transition-colors duration-300"
          >
            <span className="absolute -top-3 left-1/2 -translate-x-1/2 w-10 h-3 rounded-full opacity-60 blur-md" style={{ background: 'radial-gradient(ellipse, rgba(0,240,255,0.7) 0%, transparent 70%)' }} />
            <span className="absolute -top-1.5 left-1/2 -translate-x-1/2 w-6 h-1.5 rounded-full opacity-40 blur-sm" style={{ background: 'rgba(0,240,255,0.5)' }} />
            OET
          </a>

          {/* Desktop links */}
          <div className="hidden md:flex items-center gap-10">
            {navLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                data-testid={`nav-link-${link.label.toLowerCase()}`}
                className="text-sm font-medium tracking-wide text-zinc-400 hover:text-offWhite transition-colors duration-300 relative group"
              >
                {link.label}
                <span className="absolute -bottom-1 left-0 w-0 h-px bg-cyanGlow group-hover:w-full transition-all duration-300" />
              </a>
            ))}
          </div>

          {/* Mobile toggle */}
          <button
            data-testid="mobile-menu-toggle"
            className="md:hidden text-offWhite"
            onClick={() => setMobileOpen(!mobileOpen)}
          >
            {mobileOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile menu */}
        {mobileOpen && (
          <motion.div
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            className="md:hidden pb-6 border-t border-white/10"
          >
            {navLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                data-testid={`mobile-nav-link-${link.label.toLowerCase()}`}
                className="block py-3 text-sm text-zinc-400 hover:text-offWhite transition-colors"
                onClick={() => setMobileOpen(false)}
              >
                {link.label}
              </a>
            ))}
          </motion.div>
        )}
      </div>
    </motion.nav>
  );
};

export default Navbar;
